<template>
    <ChatProactiveOfferCard
        v-if="isVisible"
        test-id="proactive-coaching-offer"
        offer-label="coaching"
        :header="data.action_params.card_header"
        :subtext="data.action_params.card_subtext"
        :feedback="currentFeedback"
        :saved-for-later="isSaved"
        :busy="isBusy"
        :loading="isLoading"
        :error-message="errorMessage"
        cta-label="Let's chat"
        @dismiss="handleDismiss"
        @cta="handleStartChat"
        @rate="handleFeedback"
        @toggle-saved="handleToggleSaved" />
</template>

<script setup lang="ts">
import type { ParseActionsProactiveCoachingOfferAction } from "~vue/types/chat";

import ChatProactiveOfferCard from "./ChatProactiveOfferCard.vue";
import { useProactiveOfferAction } from "./useProactiveOfferAction";

const props = defineProps<{ data: ParseActionsProactiveCoachingOfferAction; lineIdx: number; messageId: number }>();
const { isVisible, isLoading, isBusy, currentFeedback, isSaved, errorMessage, handleDismiss, handleStartChat, handleFeedback, handleToggleSaved } = useProactiveOfferAction(
    () => props.data,
    props.messageId,
    props.lineIdx,
);
</script>
